module.exports = __webpack_public_path__ + "static/media/copper.00ecf7d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/copper.jpg
// module id = 192
// module chunks = 0